// index.tsx
// Application entry point

import React from 'react';
import ReactDOM from 'react-dom/client';

// Global styles (in root src folder)
import './index.css';

// Main App
import App from './App';

// Canonical-domain redirect.
//
// Firebase Hosting keeps blockcommentapp.web.app +
// blockcommentapp.firebaseapp.com serving the app even after the
// custom domain is connected — they're permanent default hostnames
// and can't be detached. To make round-master.com the One True URL
// for users / bookmarks / shared invite links, every hit on the
// legacy hostnames is bounced here BEFORE React mounts.
//
//   - Runs first thing on every page load (not waiting for React
//     to render anything — preserves the URL bar's "first paint"
//     impression of always being on the right domain).
//   - Preserves path, search, hash so a shared deep link to
//     /tournament/{id}/run lands on the same route on the new
//     domain.
//   - Uses location.replace so the old URL doesn't end up in the
//     browser's history (back button can't loop the redirect).
//   - Allows localhost / 127.0.0.1 for dev and 0.0.0.0 / *.local
//     for LAN testing, so `npm start` and local dev tooling
//     aren't disturbed.
// NOTE: roundmaster.com (no hyphen) is the intended final domain, but it's
// stuck on "Needs setup" in Firebase Hosting (a Google-side verification bug —
// its DNS is identical to the working round-master.com). Keep round-master.com
// canonical until roundmaster.com connects, then flip this back to
// 'roundmaster.com' and redeploy (see commit b4b0e15).
const CANONICAL_HOST = 'round-master.com';

(function redirectToCanonicalHost() {
  if (typeof window === 'undefined') return;
  const host = window.location.hostname;
  if (
    host === CANONICAL_HOST ||
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host === '0.0.0.0' ||
    host.endsWith('.local')
  ) {
    return;
  }
  const target =
    'https://' +
    CANONICAL_HOST +
    window.location.pathname +
    window.location.search +
    window.location.hash;
  window.location.replace(target);
})();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
